import LegacyRedirect from "@/components/LegacyRedirect";
import NotFound from "./NotFound";

const LegacyRedirectPage = () => {
  const redirect = LegacyRedirect();
  if (redirect) return redirect;
  return <NotFound />;
};

export default LegacyRedirectPage;
